// Formatting utilities for report data

export const formatDate = (value: string | Date): string => {
  if (!value) return '';
  try {
    const date = typeof value === 'string' ? new Date(value) : value;
    return date.toLocaleDateString();
  } catch {
    return String(value);
  }
};

export const formatNumber = (value: number): string => {
  if (value === null || value === undefined) return '';
  return value.toLocaleString();
};

export const formatBoolean = (value: boolean): string => {
  return value ? 'Yes' : 'No';
};

export const formatDateForApi = (date: Date | string | null): string | null => {
  if (!date) return null;
  try {
    const d = typeof date === 'string' ? new Date(date) : date;
    // Use local date components to avoid timezone shifts
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // YYYY-MM-DD
  } catch {
    return null;
  }
};

export const getTodayString = (): string => {
  return new Date().toISOString().split('T')[0];
};

export const parseDateString = (dateStr: string | null): Date | null => {
  if (!dateStr) return null;
  if (dateStr === 'today') return new Date();
  try {
    // Parse YYYY-MM-DD as local date (not UTC) to avoid timezone shifts
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // months are 0-indexed
      const day = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return new Date(dateStr);
  } catch {
    return null;
  }
};
